export default function formatKpiValue(value: number | null, currency: string, format: string, isCurrency: boolean) {
  if (value === null) {
    return "-";
  }
  if (isCurrency && format === "number") {
    const currencyFormatter = new Intl.NumberFormat("en", {
      style: "currency",
      notation: "compact",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
      currency,
    });
    return `${currencyFormatter.format(value)}`;
  }
  if (format === "%") {
    const percentageFormatter = new Intl.NumberFormat("en-US", {
      style: "percent",
      maximumFractionDigits: 2,
    });
    return `${percentageFormatter.format(Number(value / 100))}`;
  }
  if (format === "ratio") {
    const ratioFormatter = new Intl.NumberFormat("en-US", {
      style: isCurrency ? "currency" : undefined,
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currency,
    });
    return `${ratioFormatter.format(value)}`;
  }
  const valueFormatter = new Intl.NumberFormat("en", {
    notation: "compact",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
  return valueFormatter.format(value);
}
